// import { CandidateCount } from "../../../../../../models/candidateCount";
// import { Resume } from '../../../../../../models/resume';
import { JobMatchAction } from '../../../../../../models/jobMatchAction';
class UploadResumesProcessedCandidatesController {
    /*@ngInject*/
    constructor($scope, $rootScope, $timeout, $uibModal, $filter, modalService, jobMatchActionsService, alertsAndNotificationsService, resumeService, jobMatchService, candidateService, jobService, notificationsService, MESSAGECONSTANTS) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$uibModal = $uibModal;
        this.$filter = $filter;
        this.modalService = modalService;
        this.jobMatchActionsService = jobMatchActionsService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.resumeService = resumeService;
        this.jobMatchService = jobMatchService;
        this.candidateService = candidateService;
        this.jobService = jobService;
        this.notificationsService = notificationsService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        Dropzone.autoDiscover = false; // disable dropdown instantiation done in the plugin
    }
    $onInit() {
        this.userId = this.$rootScope.userDetails.id;
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.gettingCountsFlag = false;
        if (!this.candidatesCount) {
            this.candidatesCount = {};
        }
        else {
            // Check For Duplicate Id's
            this._checkDuplicatesCandidatesExists();
        }
        this.initVariables();
        if (this.candidateId !== "") {
            this.isSingleCandidateUpload = true;
        }
        //initialize the variables
        if (!_.isNull(this.jobId) && this.jobId != '') {
            this.jobContextExistsFlag = true;
            this.createJobMatchesObject = {
                companyId: this.$rootScope.userDetails.company.companyId,
                requisitionId: this.jobId,
                candidateIds: [],
                manuallyMatchedFromUI: true,
                transactionId: null,
                isAssociateCandidate: false,
                overrideNoteDetails: []
            };
        }
        this.resumeList = [];
        this.candidatesList = this.candidatesCount.candidates;
        this._setDetails();
        this._checkIfOutreachEnabled();
        this.candidatesCount.createdCount = this.candidatesCount.create ? this.candidatesCount.create.matchedCandidateCount + this.candidatesCount.create.unMatchedCandidateCount : 0;
        this.candidatesCount.updatedCount = this.candidatesCount.update ? this.candidatesCount.update.matchedCandidateCount + this.candidatesCount.update.unMatchedCandidateCount : 0;
    }
    initVariables() {
        this.resumeList = [];
        this.uploadResumesResponse = null;
        this.totalUploads = null;
        // this.candidatesList = [];
        this.candidatesToAssociateList = [];
        this.candidateCount = null;
        this.createJobMatchesObject = null;
        this.ResumeProcessedCandidatesList = [];
        // flags
        this.showCandidateUpdateFailureMessage = false;
        this.isSingleCandidateUpload = false;
        this.fileExistsFlag = false;
        this.fileUploadInProgressFlag = false;
        this.mandatoryFieldsError = false;
        this.disableSourceTypesFlag = false;
        this.resumeScoringDoneFlag = false;
        this.scoringCandidatesFlag = false;
        this.gettingCountsFlag = false;
        this.jobContextExistsFlag = false;
        this.associatingCandidatesFlag = false;
        this.selectedAllCandidatesFlag = false;
        this.displaySelectDeselectButtonFlag = true;
        this.additionalMatchRuleVerifiedCopy = false;
        this.additionalMatchRuleVerificationPassedCopy = false;
        this.isDirectCandidateUpdate = true;
        this.sendOutreachEmailMultipleResume = false;
        this.sendOutreachEmailJobContext = false;
        this.sendOutreachEmailSingleResume = false;
        this.completeResumeSavingFlag = false;
        this.completeSendOutreachAssociatingCandidatesFlag = false;
        this.isAssociateCandidatesExits = false;
    }
    _checkDuplicatesCandidatesExists() {
        if (this.candidatesCount.matchedCandidateIdAndNames) {
            this.candidatesCount.matchedCandidateIdAndNames = _.unique(this.candidatesCount.matchedCandidateIdAndNames, 'candidateId');
        }
        if (this.candidatesCount.unMatchedCandidateIdAndNames) {
            this.candidatesCount.unMatchedCandidateIdAndNames = _.unique(this.candidatesCount.unMatchedCandidateIdAndNames, 'candidateId');
        }
        if (this.candidatesCount.update) {
            if (this.candidatesCount.update.matchedCandidateIdAndNames) {
                this.candidatesCount.update.matchedCandidateIdAndNames = _.unique(this.candidatesCount.update.matchedCandidateIdAndNames, 'candidateId');
            }
            if (this.candidatesCount.update.unMatchedCandidateIdAndNames) {
                this.candidatesCount.update.unMatchedCandidateIdAndNames = _.unique(this.candidatesCount.update.unMatchedCandidateIdAndNames, 'candidateId');
            }
        }
        if (this.candidatesCount.create) {
            if (this.candidatesCount.create.matchedCandidateIdAndNames) {
                this.candidatesCount.create.matchedCandidateIdAndNames = _.unique(this.candidatesCount.create.matchedCandidateIdAndNames, 'candidateId');
            }
            if (this.candidatesCount.create.unMatchedCandidateIdAndNames) {
                this.candidatesCount.create.unMatchedCandidateIdAndNames = _.unique(this.candidatesCount.create.unMatchedCandidateIdAndNames, 'candidateId');
            }
        }
    }
    _setDetails() {
        let jobId = null;
        if (this.jobId !== '' && this.jobId !== undefined && this.jobId !== null) {
            jobId = this.jobId;
        }
        this._massageCandidateDetails();
        this._getCandidateCounts();
        this.getAllActivityTypes();
        let associateCandidatesList = [];
        this.candidatesList.map(candidate => {
            if (candidate.candidateId) {
                this.ResumeProcessedCandidatesList.push(candidate.candidateId);
            }
            if (!candidate.candidateMatchedToJob) {
                associateCandidatesList.push(candidate.candidateId);
            }
        });
        this.isAssociateCandidatesExits = associateCandidatesList.length > 0 ? true : false;
    }
    _massageCandidateDetails() {
        angular.forEach(this.candidatesList, (val, key) => {
            if (_.isNull(val.firstName)) {
                val.firstName = "-";
            }
            if (_.isNull(val.lastName)) {
                val.lastName = "-";
            }
            if (_.isNull(val.email)) {
                val.email = "-";
            }
            if (_.isNull(val.phone)) {
                val.phone = "-";
            }
            val.name = val.firstName + ' ' + val.lastName;
            if (val.mobilePhoneCountryCodePresent) {
                let phoneNumberObject = libphonenumber.parse(val.phone.toString());
                if (phoneNumberObject.phone !== undefined) {
                    val.phone = libphonenumber.format(phoneNumberObject.phone, phoneNumberObject.country, 'International');
                }
            }
            // floor the match score to the lower integer value.
            val.score = Math.floor(parseFloat(val.score));
            val.selectedFlag = false;
            if (val.score >= val.jobThresholdScore) {
                val.intelligenceScorePassFlag = true;
            }
            let candidateMatchedToJob = false;
            // Newly created candidate
            if (val.newCandidate && this.candidatesCount.create) {
                candidateMatchedToJob = !this.candidatesCount.create.unMatchedCandidateIdAndNames
                    .map(can => can.candidateId)
                    .includes(val.candidateId);
            }
            // Updated candidate
            if (!val.newCandidate && this.candidatesCount.update) {
                candidateMatchedToJob = !this.candidatesCount.update.unMatchedCandidateIdAndNames
                    .map(can => can.candidateId)
                    .includes(val.candidateId);
            }
            val.candidateMatchedToJob = candidateMatchedToJob;
            if (val.candidateMatchedToJob) {
                val.allowManualMatch = false;
            }
        });
    }
    _checkIfOutreachEnabled() {
        // this.candidateService.getOutreachEmailEnabledStatus((data) => {
        //     this.isOutreachEnabled = data;
        // }, (error) => {
        //     this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        // });
        this.isOutreachEnabled = true;
    }
    getAllActivityTypes() {
        this.activityMap = [];
        this.jobService.getActivityTypes((data) => {
            angular.forEach(data, (val, key) => {
                this.activityMap[val.value] = val.name;
            });
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    runResumeScoringForAssociate(contactDetails) {
        let isUpdate = false;
        if (contactDetails) {
            isUpdate = true;
            this.uploadResumesResponse.candidateContactDetail = contactDetails;
        }
        this.uploadResumesResponse.file = this.uploadResumesResponse.files[0];
        this.resumeService.runResumeScoringForAssociate(this.uploadResumesResponse, this.candidateId, this.jobId, isUpdate, (data) => {
            this.candidateDetailsToUpdate = data;
            if (!isUpdate) {
                this.additionalMatchRuleVerifiedCopy = this.candidateDetailsToUpdate.additionalMatchRuleVerified;
                this.additionalMatchRuleVerificationPassedCopy = this.candidateDetailsToUpdate.additionalMatchRuleVerificationPassed;
            }
            let fetchNewCandidateDetails = {
                firstName: this.candidateDetailsToUpdate.candidateConflictDetails[0].newValue,
                lastName: this.candidateDetailsToUpdate.candidateConflictDetails[1].newValue,
                email: this.candidateDetailsToUpdate.candidateConflictDetails[2].newValue,
                phoneNumber: this.candidateDetailsToUpdate.candidateConflictDetails[3].newValue
            };
            this.fetchOldCandidateDetails = {
                firstName: this.candidateDetailsToUpdate.candidateConflictDetails[0].oldValue,
                lastName: this.candidateDetailsToUpdate.candidateConflictDetails[1].oldValue,
                email: this.candidateDetailsToUpdate.candidateConflictDetails[2].oldValue,
                phoneNumber: this.candidateDetailsToUpdate.candidateConflictDetails[3].oldValue
            };
            if (this.candidateDetailsToUpdate.candidateUpdated) {
                if (!isUpdate) {
                    this.isDirectCandidateUpdate = true;
                }
                this.scoringCandidatesFlag = false;
                this.resumeScoringDoneFlag = true;
                this.candidatesList.push(fetchNewCandidateDetails);
            }
            else if (this.candidateDetailsToUpdate.candidateConflicts) {
                this.isDirectCandidateUpdate = false;
                this.showCandidateUpdateFailureMessage = true;
                this.scoringCandidatesFlag = false;
                this.resumeScoringDoneFlag = true;
                if (isUpdate) {
                    this.candidateDetailsToUpdate.additionalMatchRuleVerified = this.additionalMatchRuleVerifiedCopy;
                    this.candidateDetailsToUpdate.additionalMatchRuleVerificationPassed = this.additionalMatchRuleVerificationPassedCopy;
                }
            }
            else {
                this.isDirectCandidateUpdate = false;
                this._showConflictsModal(this.candidateDetailsToUpdate);
            }
            // else {
            //     let message = "";
            //     if(this.candidateDetailsToUpdate.additionalMatchRuleVerified && this.candidateDetailsToUpdate.additionalMatchRuleVerificationPassed) {
            //         message = "Additional matching criteria of education and experience have been verified. <br>";
            //     }
            //     message = message + "The candidate details will be updated with that in the Resume. <br> Do you really want to update the Candidate Information with the details in the Resume?";
            //     bootbox.confirm({
            //         closeButton: false,
            //         title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirmation to Update Candidate!</strong></div>",
            //         message: message,
            //         className: "zIndex1060",
            //         backdrop: true,
            //         onEscape: false,
            //         buttons: {
            //             confirm: {
            //                 label: 'Yes',
            //                 className: 'btn-info'
            //             },
            //             cancel: {
            //                 label: 'Cancel',
            //                 className: 'btn-danger'
            //             }
            //         }, callback: (result) =>  {
            //             if(result) {
            //                 this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            //                 this.runResumeScoringForAssociate(fetchNewCandidateDetails);
            //             } else {
            //                 this.candidatesList = [];
            //                 this.candidatesList.push(this.fetchOldCandidateDetails);
            //                 this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            //                 this.scoringCandidatesFlag = false;
            //                 this.resumeScoringDoneFlag = true;
            //                 this.disableNextButtonFlag = false;
            //                 this.disablePreviousButtonFlag = false;
            //             }
            //         }
            //     });
            // }
            if (this.candidateProcessedCallback) {
                this.candidateProcessedCallback();
            }
        }, (error) => {
        });
    }
    _showConflictsModal(candidateConflictDetails) {
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        $(".modal").addClass("upload-resumes-modal-medium");
        this.$timeout(() => {
            let conflictModal = this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                windowClass: 'four-dot-five-modal-medium',
                component: 'compareAndUpdateCandidateDetailsModal',
                resolve: {
                    candidateConflictDetails: () => {
                        return candidateConflictDetails;
                    }
                }
            });
            conflictModal.result.then(callbackObject => {
                if (callbackObject.callbackType == 'save') {
                    this.runResumeScoringForAssociate(callbackObject.entity);
                }
                else {
                    this.scoringCandidatesFlag = false;
                    this.resumeScoringDoneFlag = true;
                    this.candidatesList = [];
                    this.candidatesList.push(this.fetchOldCandidateDetails);
                }
            }, dismiss => {
                //do nothing
            });
        }, 300);
    }
    candidateToAssociateToggle(candidate) {
        // if it is selected, add to associate list
        if (candidate.selectedFlag) {
            this.candidatesToAssociateList.push(candidate);
        }
        else {
            // if selected is removed, remove from candidates to associate list
            _.remove(this.candidatesToAssociateList, {
                candidateId: candidate.candidateId
            });
            _.remove(this.createJobMatchesObject.overrideNoteDetails, {
                candidateId: candidate.candidateId
            });
        }
    }
    associateCandidates(successCallback) {
        angular.forEach(this.candidatesToAssociateList, (val, key) => {
            this.createJobMatchesObject.candidateIds.push(val.candidateId);
        });
        this.associatingCandidatesFlag = true;
        let associatingDialog = bootbox.dialog({
            message: '<p class="text-center">Adding Candidates <i class="fa fa-spinner fa-spin"></i></p>',
            closeButton: false
        });
        this.createJobMatchesObject.isAddCandidate = true;
        this.jobMatchService.createJobMatches(this.createJobMatchesObject, (data) => {
            this.associatingCandidatesFlag = false;
            associatingDialog.modal('hide');
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            angular.forEach(this.candidatesToAssociateList, (val, key) => {
                // find each associated candidate in the original candidates list
                let index = _.findIndex(this.candidatesList, {
                    candidateId: val.candidateId
                });
                // for each candidate, set the added successfully flag to true and selected flag to false
                this.candidatesList[index].candidateMatchedToJob = true;
                this.candidatesList[index].statusOfJobMatch = 'Candidate Added.';
                this.candidatesList[index].selectedFlag = false;
                this.candidatesList[index].jobMatchManuallyCreated = (this.candidatesList[index].score < this.candidatesList[index].jobThresholdScore);
                //update notification payload
                if (this.candidatesCount.update) {
                    if (this.candidatesCount.update.unMatchedCandidateIdAndNames && this.candidatesCount.update.unMatchedCandidateIdAndNames.length > 0) {
                        this.candidatesCount.update.unMatchedCandidateIdAndNames.forEach(candidate => {
                            if (candidate.candidateId == val.candidateId) {
                                this.candidatesCount.update.unMatchedCandidateCount--;
                                this.candidatesCount.update.matchedCandidateCount++;
                                this.candidatesCount.update.matchedCandidateIdAndNames.push(Object.assign({}, candidate, { jobMatchManuallyCreated: this.candidatesList[index].jobMatchManuallyCreated }));
                                _.remove(this.candidatesCount.update.unMatchedCandidateIdAndNames, {
                                    candidateId: val.candidateId
                                });
                            }
                        });
                    }
                }
                if (this.candidatesCount.create) {
                    if (this.candidatesCount.create.unMatchedCandidateIdAndNames && this.candidatesCount.create.unMatchedCandidateIdAndNames.length > 0) {
                        this.candidatesCount.create.unMatchedCandidateIdAndNames.forEach(candidate => {
                            if (candidate.candidateId == val.candidateId) {
                                this.candidatesCount.create.unMatchedCandidateCount--;
                                this.candidatesCount.create.matchedCandidateCount++;
                                this.candidatesCount.create.matchedCandidateIdAndNames.push(Object.assign({}, candidate, { jobMatchManuallyCreated: this.candidatesList[index].jobMatchManuallyCreated }));
                                _.remove(this.candidatesCount.create.unMatchedCandidateIdAndNames, {
                                    candidateId: val.candidateId
                                });
                            }
                        });
                    }
                }
            });
            this.candidatesCount.candidates = JSON.parse(angular.toJson(this.candidatesList));
            //Send outreach
            if (this.sendOutreachEmailJobContext && this.isOutreachEnabled) {
                let candidateIds = [];
                this.candidatesList.map(candidate => {
                    if (candidate.candidateMatchedToJob) {
                        candidateIds.push(candidate.candidateId);
                    }
                });
                if (candidateIds.length > 0) {
                    this._sendCandidateOutReachEmail(candidateIds, () => { });
                }
            }
            // make the candidates to associate list as empty.
            this.candidatesToAssociateList = [];
            // get the candidate counts again as manually matched counts might have changed.
            this._getCandidateCounts();
            if (successCallback) {
                successCallback();
            }
            else {
                this.alertsAndNotificationsService.showBannerMessage("Candidates have be successfully added to the job", "success");
                this.$rootScope.$broadcast('refreshJobWorkflow', null);
                //save api
                if (this.notificationId) {
                    this.notificationsService.saveCandidateResumeNotification(this.notificationId, this.candidatesCount, (data) => {
                        if (this.completeCallback) {
                            this.completeCallback();
                        }
                    }, error => {
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    });
                }
                else {
                    if (this.completeCallback) {
                        this.completeCallback();
                    }
                }
            }
        }, (error) => {
            this.associatingCandidatesFlag = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _getCandidateCounts() {
        this.displaySelectDeselectButtonFlag = (this.candidatesCount.create && this.candidatesCount.create.unMatchedCandidateCount !== 0) || (this.candidatesCount.update && this.candidatesCount.update.unMatchedCandidateCount !== 0);
    }
    showOverrideCandidateSuspensionModal(candidate) {
        let candidateId = candidate.candidateId;
        let candidateName = candidate.name;
        let suspendedMonths = candidate.overrideFor === "RELEASE" ? candidate.releasedCandidateDetailDTO.numberOfMonthsToWait : candidate.jobLeftCandidateDetailDTO.numberOfMonthsToWait;
        let releaseDate = candidate.overrideFor === "RELEASE" ? candidate.releasedCandidateDetailDTO.releasedAt : candidate.jobLeftCandidateDetailDTO.leftAt;
        let allowOverride = candidate.allowOverride;
        let releasedJobDetails = candidate.overrideFor === "RELEASE" ? candidate.releasedCandidateDetailDTO : candidate.jobLeftCandidateDetailDTO;
        let type = candidate.overrideFor === "RELEASE" ? "release" : "jobLeft";
        if (allowOverride) {
            $(".modal").addClass("upload-resumes-modal-medium");
            this.$timeout(() => {
                let warningModal = this.$uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    backdrop: 'static',
                    windowClass: 'four-dot-five-modal-medium',
                    component: 'uploadResumesActionsModal',
                    resolve: {
                        candidateId: () => {
                            return candidateId;
                        },
                        candidateName: () => {
                            return candidateName;
                        },
                        suspendedMonths: () => {
                            return suspendedMonths;
                        },
                        releaseDate: () => {
                            return releaseDate;
                        },
                        allowOverride: () => {
                            return allowOverride;
                        },
                        releasedJobDetails: () => {
                            return releasedJobDetails;
                        },
                        type: () => {
                            return type;
                        }
                    }
                });
                warningModal.result.then((callbackObject) => {
                    if (callbackObject.callbackType == 'save') {
                        let index = _.findIndex(this.candidatesList, {
                            candidateId: candidate.candidateId
                        });
                        this.createJobMatchesObject.overrideNoteDetails.push(callbackObject.entity);
                        this.candidatesList[index].allowManualMatch = true;
                        this.candidatesList[index].showOverride = false;
                        this.candidatesList[index].statusOfJobMatch = 'Candidate is made available for matching.';
                        this.candidatesList[index].selectedFlag = true;
                        this.candidateToAssociateToggle(this.candidatesList[index]);
                    }
                }, dismiss => {
                    //do nothing
                });
            }, 300);
        }
        else {
            let displayHtmlText = "";
            if (type == 'release') {
                displayHtmlText = "Candidate '<span class='emerald'>" + candidateName + "</span>' cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of candidate's previous release. ";
                displayHtmlText = displayHtmlText + "Candidate was previously released on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
                displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
            }
            else {
                displayHtmlText = "Candidate <span class='emerald'>'" + candidateName + "'</span> cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of leaving previous job. ";
                displayHtmlText = displayHtmlText + "Candidate left previous job on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
                displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
            }
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Cannot add candidate</strong></div>",
                message: displayHtmlText,
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: () => {
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        }
    }
    toggleSelectAllCandidates() {
        if (this.selectedAllCandidatesFlag) {
            // if selectAllCandidates was already selected, remove all selections
            angular.forEach(this.candidatesList, (val, key) => {
                // if candidate was not already added successfully and was selected, de select it and remove it from associate list
                if (!val.candidateMatchedToJob && val.selectedFlag && val.allowManualMatch) {
                    val.selectedFlag = false;
                    // if selected is removed, remove from candidates to associate list
                    _.remove(this.candidatesToAssociateList, {
                        candidateId: val.candidateId
                    });
                }
            });
            this.selectedAllCandidatesFlag = false;
        }
        else {
            // if selectAllCandidates was not already selected
            angular.forEach(this.candidatesList, (val, key) => {
                // if candidate was not already added successfully and also not already selected, select it and add to associate list
                if (!val.candidateMatchedToJob && !val.selectedFlag && val.allowManualMatch) {
                    val.selectedFlag = true;
                    this.candidatesToAssociateList.push(val);
                }
            });
            this.selectedAllCandidatesFlag = true;
        }
    }
    jobCompare(candidate) {
        let actionObject = new JobMatchAction("Candidate Job Comparison", "CANDIDATE_JOB_COMPARE", true, null);
        candidate.id = candidate.candidateId;
        candidate.jobMatchJobId = this.jobId;
        this.jobMatchActionsService.performAction('uploadResumes', actionObject, candidate, () => {
        }, () => {
        });
    }
    displayProcessedCandidates(activity) {
        $(".modal").addClass("upload-resumes-modal-medium");
        this.$timeout(() => {
            let displayCandidatesModal = this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                component: 'uploadResumesTransactionCandidatesModal',
                windowTopClass: 'four-dot-five-modal-large',
                resolve: {
                    resumeProcessedObject: () => {
                        return this.candidatesCount;
                    },
                    activity: () => {
                        return activity;
                    },
                    modalType: () => {
                        return "resumeProcessed";
                    },
                    activityMap: () => {
                        return this.activityMap;
                    }
                }
            });
            displayCandidatesModal.result.then(() => {
                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            }, () => {
                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            });
        }, 300);
    }
    _sendCandidateOutReachEmail(candidateIds, successCallback) {
        let candidateIdsWithCandidateType = [];
        candidateIds.forEach(candidateId => {
            candidateIdsWithCandidateType.push({ id: candidateId, candidateType: "OWN_CANDIDATES" });
        });
        let outreachObject = {
            candidates: candidateIdsWithCandidateType,
            userId: this.userId,
            companyId: this.companyId,
            clientOrBuId: null
        };
        this.candidateService.sendOutreachEmail(outreachObject, (data) => {
            this.alertsAndNotificationsService.showBannerMessage(data.message, 'success');
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (successCallback) {
                successCallback();
            }
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    completeResumeProcessed(type) {
        this.completeResumeSavingFlag = true;
        let isSendOutreachEmailChecked = (type === 'multipleResume') ? this.sendOutreachEmailMultipleResume : this.sendOutreachEmailSingleResume;
        if (isSendOutreachEmailChecked && this.ResumeProcessedCandidatesList.length > 0 && this.isOutreachEnabled) {
            this._sendCandidateOutReachEmail(this.ResumeProcessedCandidatesList, () => {
                this.completeResumeSavingFlag = false;
                if (this.completeCallback) {
                    this.completeCallback();
                }
            });
        }
        else {
            this.completeResumeSavingFlag = false;
            if (this.completeCallback) {
                this.completeCallback();
            }
        }
    }
    sendOutreachToAssociatedCandidates() {
        this.completeSendOutreachAssociatingCandidatesFlag = true;
        let candidateIds = [];
        this.candidatesList.map(candidate => {
            if (candidate.candidateId) {
                candidateIds.push(candidate.candidateId);
            }
        });
        if (this.sendOutreachEmailJobContext && candidateIds.length > 0 && this.isOutreachEnabled) {
            this._sendCandidateOutReachEmail(candidateIds, () => {
                this.completeSendOutreachAssociatingCandidatesFlag = false;
                if (this.completeCallback) {
                    this.completeCallback();
                }
            });
        }
        else {
            this.completeSendOutreachAssociatingCandidatesFlag = false;
            if (this.completeCallback) {
                this.completeCallback();
            }
        }
    }
}
// UploadResumesProcessedCandidatesController.$inject = ['$rootScope', '$uibModal', '$timeout', 'modalService'];
// UploadResumesProcessedCandidatesController.$inject = '[$scope', '$rootScope', '$timeout', '$uibModal', '$filter', 'modalService', 'jobMatchActionsService', 'alertsAndNotificationsService', 'resumeService', 'jobMatchService', 'candidateService', 'jobService', 'MESSAGECONSTANTS'];
UploadResumesProcessedCandidatesController.$inject = ['$scope', '$rootScope', '$timeout', '$uibModal', '$filter', 'modalService', 'jobMatchActionsService', 'alertsAndNotificationsService', 'resumeService', 'jobMatchService', 'candidateService', 'jobService', 'notificationsService', 'MESSAGECONSTANTS'];
import * as TEMPLATE from 'raw-loader!./upload-resumes-processed-candidates.html';
export const UploadResumesProcessedCandidatesComponent = {
    selector: 'uploadResumesProcessedCandidates',
    component: {
        bindings: {
            candidatesCount: '<',
            jobId: '@',
            candidateId: '@',
            notificationId: '@',
            headingTitle: '@',
            cancelCallback: '&',
            candidateProcessedCallback: '&',
            completeCallback: '&'
        },
        template: TEMPLATE.default,
        controller: UploadResumesProcessedCandidatesController
    }
};
//# sourceMappingURL=upload-resumes-processed-candidates.component.js.map